import React, {Component} from 'react';
import {Button, Modal, Grid, Form, Card} from 'semantic-ui-react';
import {showToast} from "../../actions/ToastAction";
import connect from "react-redux/es/connect/connect";
import {ticketCheckModal} from "../../actions/TicketCheckActions";
import CheckTicket from "../services/CheckTicket";

class TicketCheckDialog extends Component {

    constructor() {
        super();
        this.state = {
            ticket:null,
        };
    }

    handleClose = () => {
        this.props.ticketCheckModal({open: false, ticket:{id:null, product:{name:''}}});
    };

    render() {
        return (
            <div>
                <Modal size='small' dimmer='inverted' open={this.props.dialog.open} onClose={this.handleClose}>
                    <Modal.Header>Tiquetera Nº {this.props.dialog.code} - {this.props.dialog.ticket.product.name}</Modal.Header>
                    <Modal.Content>
                        <Modal.Description>
                            <Form>
                                <Grid>
                                    <Grid.Row>
                                        <Grid.Column>
                                            <Card.Group itemsPerRow={10}>
                                                {
                                                    (Array(this.props.dialog.ticket.quantity)).fill().map((_, i) => {
                                                        return <CheckTicket
                                                            key={i+1}
                                                            checked={this.props.dialog.ticket.checked < i+1}
                                                            number={i+1}
                                                            ticket={this.props.dialog.ticket.id}
                                                            id={this.props.dialog.id}
                                                        />
                                                    })
                                                }
                                            </Card.Group>
                                        </Grid.Column>
                                    </Grid.Row>
                                </Grid>
                            </Form>
                        </Modal.Description>
                    </Modal.Content>
                    <Modal.Actions>
                        <Button icon='x' labelPosition='left' onClick={this.handleClose} content="Cerrar"/>
                    </Modal.Actions>
                </Modal>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        dialog: state.get('ticket_check_dialog'),
    };
}

function mapDispatchToProps(dispatch) {
    return {
        ticketCheckModal(data) {
            dispatch(ticketCheckModal(data));
        },
        showToast(data){
            dispatch(showToast(data))
        }
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(TicketCheckDialog);


// WEBPACK FOOTER //
// ./src/components/sale/TicketCheckDialog.js